const logoutUser = (instance) => {
  instance.logoutRedirect({
    postLogoutRedirectUri: "/",
    mainWindowRedirectUri: "/",
    account: instance.getActiveAccount(),
  });
};

export default logoutUser;
